<template>
	<section class="accountInfo">
		<Nav title="账户信息" />
		<div class="num">
			<p>H5{{version}}</p>
		</div>
		<div class="button_wrap">
			<van-button type="primary" @click="logOutFn">退出登录</van-button>
		</div>
		<p class="del_link" @click="openAccoutDelFn">注销账户</p>
		<div class="beian">
			<p>鲁ICP备2022033069号-3A</p>
		</div>
	</section>
</template>

<script>
import Nav from "components/Nav";
import loginServer from "api/login";
import { Dialog } from 'vant';

export default {
	name: 'accountInfo',
	components: {
		Nav,
	},
	data() {
		return {
			version: this.$store.state.versionData.versionNumber
		}
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		logOutFn() {
			loginServer.Logout().then(() => {
                localStorage.clear()
                this.$router.push({ name: 'setting'})
			}).catch(() => {
                localStorage.clear()
                this.$router.push({ name: 'setting'})
                console.log('服务端退出失败，客户端强制退出')
            })
			
		},

		openAccoutDelFn() {
			Dialog.alert({ message: '注销账号操作不可恢复。请在设置-联系客服中提交注销账户申请，我们将在3个工作日内审核并完成账户注销工作。'})
		},		
	}
}
</script>

<style lang="scss">
	.accountInfo {
		padding-top: 46px;
		.num {
			padding-top: 120px;
			text-align: center;
			p {
				color: #7D8290;
				font-size: 15px;
				margin-bottom: 4px;
			}
		}
		.button_wrap{
			margin: 0 auto;
			width: 200px;
			background: #055CE8;
			border-radius: 50px;
			overflow: hidden;
			margin-top: 20px;
			margin-bottom: 100px;
			.van-button--primary {
				width: 100%;
				height: 40px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				border-radius: 0;
				

			}
		}

		.del_link {
			position: fixed;
			bottom: 100px;
			width: 100%;
			text-align: center;
			font-size: 13px;
			color: #6f6f6f;
			text-decoration:underline;
		}
		
		.beian {
			position: fixed;
			bottom: 30px;
			width: 100%;
			text-align: center;
			p {
				color: #7D8290;
				font-size: 11px;
				margin-bottom: 4px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/setting/account/Info.vue